export default "__VITE_ASSET__DWpwtOOC__"